import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import {
  requestGetVariantsByIds,
  VariantSummary
} from "./getVariantsByIds.request";

const useGetVariantsByIds = (
  ids: string[],
  options?: QueryOptions<VariantSummary[], ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["products", "admin", "variants-by-ids", ids],
    queryFn: async () => await requestGetVariantsByIds(ids),
    enabled: ids.length > 0,
    onError: toastServerError,
    ...options
  });

  return { variants: data ?? [], ...rest };
};

export default useGetVariantsByIds;
